import * as userRequest from "@/utils/userRequest";

export default async function checkRequiredKYCForBonusService(
    token: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.get("affiliates/check-require-kyc", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (res) {
            onSuccess && onSuccess(res);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ checkRequiredKYCForBonusService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
